import styled from 'styled-components';

const SwitchStyled = styled.div`
  .Switch {
    &__wrapper {
      opacity: ${(props) => props.isDisabled ? "0.6" : "1"};
      position: relative;
      width: 48px;
      height: 24px;
      border: none;
      border-radius: 96px;
      overflow: hidden;
      margin-top: 4px;

      &:hover {
        opacity: 0.6;
      }

      &:focus-within {
        box-shadow: ${(props) => props.checked ? "0 0 2px 0 var(--palette-primary, #4611cf)" : "0 0 2px 0 #707070"};
        border-radius: 96px;
      }
    }

    &__label {
      padding-bottom: 4px;
      font-size: 12px;
      color: #11111180;
    }

    &__description {
      font-size: 10px;
      color: #11111180;
    }

    &__input {
      width: 100%;
      height: 100%;
      border-radius: 96px;
      cursor: ${(props) => props.isDisabled ? "default" : "pointer"};

      &:checked + .Switch__slider {
        background-color: var(--palette-primary, #4611cf);
      }

      &:checked + .Switch__slider:before {
        transform: translate(24px, -50%);
        background-color: #ffffff;
      }
    }

    &__slider {
      pointer-events: none;
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #707070;
      transition: 0.4s;

      &:before {
        pointer-events: none;
        position: absolute;
        content: "";
        height: 16px;
        width: 16px;
        left: 4px;
        top: 50%;
        transform: translateY(-50%);
        background-color: #ffffff;
        transition: 0.4s;
        border-radius: 50%;
      }
    }

    &__icon {
      position: absolute;
      display: flex;
      align-items: center;
      transform: translateY(-50%);
      top: 50%;

      &--on {
        left: 4px;
      }

      &--off {
        right: 4px;
      }
    }

    &__errorMessage {
      display: inline-block;
      padding-top: 4px;
      font-size: 12px;
      color: #eb5757;
    }
  }
`;

export { SwitchStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
